const ROOT_SELECTOR = '[data-topic-selector]';
const DESKTOP_SELECTOR = '[data-topic-selector-desktop]';
const TAB_SELECTOR = '[data-topic-selector-tab]';
const PANEL_SELECTOR = '[data-topic-selector-panel]';

export function initTopicSelector(): void {
  document.querySelectorAll<HTMLElement>(ROOT_SELECTOR).forEach(initTopicSelectorRoot);
}

function initTopicSelectorRoot(root: HTMLElement): void {
  const desktop = root.querySelector<HTMLElement>(DESKTOP_SELECTOR);
  if (!desktop) return;

  const tabs = desktop.querySelectorAll<HTMLButtonElement>(TAB_SELECTOR);
  const panels = desktop.querySelectorAll<HTMLElement>(PANEL_SELECTOR);

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const id = tab.getAttribute('data-topic-selector-tab');
      if (!id) return;

      tabs.forEach((item) => {
        const isActive = item === tab;
        item.classList.toggle('topic-selector__tab--active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const isActive = panel.getAttribute('data-topic-selector-panel') === id;
        panel.classList.toggle('topic-selector__panel--hidden', !isActive);
      });
    });
  });
}
